import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config_path } from "../../router/config.path";
import LoginView from "./LoginView";
import crmservices from '../../wsclient';
import { useTranslation } from "react-i18next";
import VerificationController from "../verification/VerificationController";
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";

export default function LoginController(props){
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showProcessing, setShowProcessing] = useState(false);
    const [message, setMessage] = useState(null);
    const [active, setActive] = useState('main');

    const orgId = document._portalConfig.organisation_id;
    const schedulingTeam = document._portalConfig.scheduling_team;

    useEffect(() => {
        let sessionVerify = localStorage.getItem("access_token_temp"); // getSessionVerify return promise ??
        if( sessionVerify && sessionVerify !== "undefined" ) {
            setActive('verify')
        }
    }, [])


    const onSubmit  =  async(data) => {
        console.log("AAAA onSubmit data: ", data)
        setShowProcessing(true);
        try {
            let result = await crmservices.authentication.authenticate({...data, organisation_id: orgId, schedulingTeam: schedulingTeam});
            console.log("AAAA Login result: ", result)
            if (result.code == "OK") {
                if (result.data.two_factor_required && result.data.two_factor_required == true) {
                    setActive('verify');
                } else {
                    navigate(config_path.home);
                }
            } else if (result.code == 'TOO_MANY_REQUESTS') {
                showMessage({ status: true, message: t('TOO_MANY_REQUESTS') });
            } else {
                showMessage({ status: true, message: t('INVALID_EMAIL_LOGIN') });
            }
        } catch (error) {
            console.log("AAAA onSubmit exception: ", error)
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    return(
        <>
            {active == 'main' && <LoginView
                showProcessing={showProcessing}
                message={message}
                onSubmit={onSubmit}
            />}
            {active == 'verify' && <VerificationController
                setShowVerify={() => {httpBackOfficeUtil.clearSessionForVerify(); setActive('main')}}
                setShowProcessing={setShowProcessing}
                showMessage={showMessage}
            />}
        </>
    )
}